import React, { useEffect, useState } from 'react';
import './Nav.css';
import logo from './Logo.png';


function Nav() {

    const [show, handleShow] = useState(false);

    const transitionNavBar = () =>{
        if(window.scrollY>100){
            handleShow(true);
        }else{
            handleShow(false);
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", transitionNavBar);
        return() => window.removeEventListener('scroll', transitionNavBar);    
    }, [])

    return (
        <div className={`nav ${show && 'nav__black'}`}>
            <div className="nav__contents">
                <img 
                    className='nav__logo'
                    src = {logo}
                    alt = 'logo'
                />
                <img 
                    className='nav__avatar'
                    src='https://mir-s3-cdn-cf.behance.net/project_modules/disp/bf6e4a33850498.56ba69ac3064f.png'
                    alt='avatar'
                />
            </div>
        </div>
    )
}

export default Nav;
